import {
  base_colorAction,
  input_backgroundDefault,
  input_borderDefault,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { transition_slow } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_medium,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.VendorSelectHandle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing(2)};
    width: 100%;
    min-height: ${spacing(12)};
    padding: ${spacing(2)} ${spacing(4)};
    box-sizing: border-box;
    border: 1px solid ${input_borderDefault};
    border-radius: ${cornerRadius};
    background-color: ${input_backgroundDefault};
    appearance: none;
    font: inherit;
    text-align: left;
    cursor: pointer;

    &.selected,
    &:hover {
      border-color: ${base_colorAction};
    }

    &:focus-visible {
      outline: 2px solid ${base_colorAction};
      outline-offset: 1px;
    }

    .content {
      display: flex;
      align-items: center;
      gap: ${spacing(3)};
      overflow: hidden;
      flex: 1;
      min-width: 0;
    }

    .avatar {
      flex-shrink: 0;
    }

    .identity {
      display: flex;
      flex-direction: column;
      gap: ${spacing(1)};
      overflow: hidden;
      min-width: 0;
    }

    .name {
      ${font_md};
      font-family: ${font_family_weight_medium};
      color: ${text_colorTextPrimary};
    }

    .email {
      ${font_sm};
      color: ${text_colorTextSecondary};
    }

    .placeholder {
      ${font_md};
      color: ${text_colorTextSecondary};
    }

    .ellipsis {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .chevron {
      flex-shrink: 0;
      transition: transform ${transition_slow};
      transform: rotate(180deg);
      &.open {
        transform: rotate(0deg);
      }
    }
  }
`
